module.exports = __webpack_public_path__ + "static/sperm.13c6e66f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sperm.png
// module id = ./assets/sperm.png
// module chunks = 158396747691188